import { SpinnerIndicator } from "components/CallServer";
import IconFollow from "components/Icons/IconFollow";
import MuiRegularButton, { MuiRegularButtonColors, MuiRegularButtonProps } from "components/MuiExtras/Button/MuiRegularButton";
import * as React from "react";
import { useTranslation } from 'react-i18next';

interface IProps {
    followColor?: MuiRegularButtonColors,
    unfollowColor?: MuiRegularButtonColors,
    following: boolean;
    updating?: boolean;
}

type Props = IProps & MuiRegularButtonProps;

const ButtonFollow: React.FC<Props> = (props) => {
    const { updating, following, followColor, unfollowColor, justIcon, ...rest } = props;
    const { t } = useTranslation();
    return (
        <MuiRegularButton
            {...rest}
            justIcon={justIcon}
            color={following ? followColor || "success" : unfollowColor || "muted"}
            disabled={updating}
        >
            <IconFollow fixedWidth />
            {!justIcon && <span>{following ? t("Common.Buttons.FollowingText") : t("Common.Buttons.FollowText")}</span>}

            {updating && <SpinnerIndicator />}
        </MuiRegularButton>
    );
};

export default ButtonFollow;
